import React from 'react';
import {DragAndDropContainerStyled} from "../../../styled/Resume";
import { FiUpload } from "react-icons/fi";
import { FaCheckCircle } from 'react-icons/fa';
import { SecondaryLightButtonStyled } from "../../../styled/Buttons";
import { useTheme } from "../../UI/Theme/ThemeContext";


const RenderDragAndDrop = (props) => {
    const {handleDrop, dragDropRef, fileError, file, handleUploadFile} = props;
    const { themeName } = useTheme();
    const selectedColor = themeName === 'dark' ? 'rgba(111, 203, 209, 1)' : 'rgba(0, 153, 144, 1)';
    return (
        <DragAndDropContainerStyled
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
            onClick={() => { try { if (dragDropRef && dragDropRef.current) dragDropRef.current.click(); } catch(_) {} }}
            onTouchStart={() => { try { if (dragDropRef && dragDropRef.current) dragDropRef.current.click(); } catch(_) {} }}
            fileError={fileError}
            theme={themeName}
        >
            {
                file &&
                <>
                    <p className="dropFileInfo dropFileName">{file.name}</p>
                    <p className="dropFileInfo selected">
                        <FaCheckCircle aria-hidden="true" style={{ color: selectedColor, fontSize: '.8rem', verticalAlign: 'middle', marginRight: 6 }} />
                        <span>selected</span>
                    </p>
                </>
            }
            {
                !file &&
                <>
                    <p className="dropFileInfo">
                        Drag and drop file here <br/>
                        <span className="">Accepted files include; Txt, Docx & PDF *</span>
                    </p>
                    <p className="dropFileInfo">
                        or
                    </p>
                    <SecondaryLightButtonStyled>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a
                            href="#"
                            onClick={(e) => { try { e.preventDefault(); e.stopPropagation(); if (dragDropRef && dragDropRef.current) dragDropRef.current.click(); } catch(_) {} }}
                            onTouchStart={(e) => { try { e.preventDefault(); e.stopPropagation(); if (dragDropRef && dragDropRef.current) dragDropRef.current.click(); } catch(_) {} }}
                            title="Upload file"
                        >
                            <FiUpload />&nbsp;&nbsp; Upload file
                        </a>
                    </SecondaryLightButtonStyled>
                </>


            }
            <input
                type="file"
                accept=".doc,.docx,.pdf,.txt"
                onChange={handleUploadFile}
                onClick={(e) => { try { e.stopPropagation(); } catch(_) {} }}
                onTouchEnd={(e) => { try { e.stopPropagation(); } catch(_) {} }}
                style={{ display: 'none' }}
                ref={dragDropRef}
            />
        </DragAndDropContainerStyled>
    );
}

export default RenderDragAndDrop